import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Shield, DollarSign } from 'lucide-react';
import { Logo } from '../components/Logo';
import { motion } from 'framer-motion';
export function Inversiones() {
  return <div className="min-h-screen bg-brand-black flex flex-col" data-id="element-384">
      <nav className="border-b border-brand-gold/20 p-6" data-id="element-385">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-386">
          <Link to="/" data-id="element-387">
            <Logo data-id="element-388" />
          </Link>
          <Link to="/" className="text-brand-gold hover:text-brand-white transition-colors flex items-center gap-2 font-medium" data-id="element-389">
            <ArrowLeft className="w-4 h-4" data-id="element-390" />
            Volver al inicio
          </Link>
        </div>
      </nav>

      <main className="flex-grow flex items-center justify-center p-6" data-id="element-391">
        <div className="max-w-4xl mx-auto w-full" data-id="element-392">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center mb-16" data-id="element-393">
            <div className="inline-block px-4 py-1 rounded-full border border-brand-gold/30 text-brand-gold text-sm font-medium mb-6" data-id="element-394">
              2% MENSUAL · 24% ANUAL EN DÓLARES
            </div>
            <h1 className="font-heading text-6xl md:text-8xl text-brand-white mb-4" data-id="element-395">
              TU CAPITAL EN <span className="text-brand-gold" data-id="element-396">MOVIMIENTO</span>
            </h1>
            <p className="text-xl text-brand-white/70 max-w-2xl mx-auto" data-id="element-397">
              Sumate a la red de inversores de Flash & Go y generá ingresos
              pasivos en dólares desde el primer mes.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-398">
            {[{
            icon: DollarSign,
            title: 'Desde U$S 10.000',
            desc: 'Inversión mínima accesible para comenzar a generar retornos.'
          }, {
            icon: TrendingUp,
            title: '2% mensual',
            desc: 'Rentabilidad fija en dólares (24% anual), superando opciones tradicionales.'
          }, {
            icon: Shield,
            title: 'Pagos Mensuales',
            desc: 'Cobrá tus intereses mes a mes sin demoras ni complicaciones.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: i * 0.1 + 0.2
          }} className="bg-[#111] border border-brand-gold/20 p-8 rounded-lg text-center hover:border-brand-gold/50 transition-colors" data-id="element-399">
                <div className="w-12 h-12 rounded-full bg-brand-gold/10 flex items-center justify-center mx-auto mb-6" data-id="element-400">
                  <item.icon className="w-6 h-6 text-brand-gold" data-id="element-401" />
                </div>
                <h3 className="font-heading text-2xl text-brand-white mb-3" data-id="element-402">
                  {item.title}
                </h3>
                <p className="text-brand-white/60 text-sm" data-id="element-403">{item.desc}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6
        }} className="bg-[#111] border border-brand-gold/30 p-8 md:p-12 rounded-xl text-center" data-id="element-404">
            <h2 className="font-heading text-4xl text-brand-white mb-4" data-id="element-405">
              ¿Listo para invertir?
            </h2>
            <p className="text-brand-white/70 mb-8 max-w-xl mx-auto" data-id="element-406">
              Dejanos tus datos y un asesor financiero se comunicará con vos
              para explicarte el modelo de negocio en detalle.
            </p>
            <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-407">
              CONTACTAR A UN ASESOR
            </a>
          </motion.div>
        </div>
      </main>
    </div>;
}